<div class="h-screen w-screen">
  <div class="h-5/6 flex items-center justify-center">
    <p class="text-xl">Activating your account...</p>
  </div>
  <app-footer></app-footer>
</div>
